var render, staticRenderFns
import script from "./wBase.vue?vue&type=script&lang=js&"
export * from "./wBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d86163c6",
  null
  
)

export default component.exports